var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{attrs:{"shadow":"never"}},[_c('el-row',{attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":12}},[_c('el-row',{staticClass:"row"},[_c('TableTitleComponent',{attrs:{"title":"个人每日产能"}}),_c('UserDayCapacity')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }